module.exports = __webpack_public_path__ + "img/60f6.66231b5a.jpg";